import { diInject } from '@di/di';
export class WidgetAdApi {
    constructor() {
        this.ad = diInject(0 /* Token.AD */);
        this._creativeConfig = diInject(2 /* Token.CREATIVE_CONFIG */);
        this.parameters = this.ad.parameters;
        this.customDomain = this._creativeConfig.CUSTOM_AD_DOMAIN;
    }
    trackCustomEvent(eventData) {
        var _a;
        (_a = this.ad.tracking) === null || _a === void 0 ? void 0 : _a.trackCustomEvent(eventData);
    }
    // eslint-disable-next-line
    trackCustomProgressEvent(eventData) {
        // removed in CIA-280
    }
}
